import { extensionOf } from "~/ai-chat/model/save-resource-action";

// The file types Istari AI can actually read the CONTENTS of today: text-based
// files the backend surfaces via read_document_text. Anything else — PDF, Office
// docs, images, CAD/mesh, archives, binaries — reaches the model as a
// {resource_id, name} pointer only: it can act on the resource by id, but it
// cannot see the bytes, so it must not summarize or quote what's inside.
//
// This is the single source of truth for both the composer's attach warning and
// the serialized-context annotation. When document extraction ships (roadmap
// Appendix A Phase 1), add pdf/docx/etc. here — a one-line change flips both.
export const READABLE_FILE_TYPES: readonly string[] = [
  "md",
  "markdown",
  "txt",
  "text",
  "log",
  "csv",
  "tsv",
  "json",
  "jsonl",
  "yaml",
  "yml",
  "toml",
  "ini",
  "cfg",
  "xml",
  "html",
  "htm",
  "rst",
  "sql",
  "py",
  "js",
  "jsx",
  "ts",
  "tsx",
  "sh",
];

// True when the agent can read the file's text content, false when it can only
// reference the resource by id. Files without an extension are treated as
// unreadable — the backend can't infer a text decoder without one.
export function isReadableFileType(fileName: string): boolean {
  const extension = extensionOf(fileName);
  return extension.length > 0 && READABLE_FILE_TYPES.includes(extension);
}
